import { matchPath, useLocation } from "react-router-dom";
import { useApp } from "../context/AppContext";
import Seo from "./Seo";
import { KIND_LABEL } from "../explore";

/* Every SPA route → a baseline title (pages with dynamic data mount their own <Seo>, which overrides this).
   Anything not listed here is a genuine 404. [pattern, i18n key, noindex] */
const ROUTES = [
  ["/", "title.home"],
  ["/map", "title.map"],
  ["/knowledge", "title.knowledge"],
  ["/provenance", "title.provenance"],
  ["/provenance/dashboard", "title.dashboard", true],
  ["/provenance/auth", "title.auth", true],
  ["/auth", "title.auth", true],
  ["/auth/callback", "title.auth", true],
  ["/dashboard", "title.hub", true],
  ["/trader/dashboard", "title.trader", true],
  ["/verify/:certId", "title.verify", true],
  ["/admin", "title.admin", true],
  ["/admin/login", "title.admin", true],
  ["/admin/:section", "title.admin", true],
  ["/varieties", "kind:varieties"],
  ["/varieties/directory", "dir.title"],
  ["/varieties/:slug", "kind:varieties"],
  ["/oases", "kind:oases"],
  ["/oases/:slug", "kind:oases"],
  ["/routes", "kind:routes"],
  ["/routes/:slug", "kind:routes"],
  ["/gallery", "kind:gallery"],
  ["/culinary", "kind:culinary"],
  ["/culinary/:slug", "kind:culinary"],
  ["/stories", "kind:stories"],
  ["/stories/:slug", "kind:stories"],
  ["/terms", "legal.terms.title"],
  ["/privacy", "legal.privacy.title"],
  ["/dmca", "legal.dmca.title"],
  ["/contact", "contact.title"],
  ["/souq", "souq.title"],
  ["/souq/auth", "title.auth", true],
  ["/souq/dashboard", "title.buyer", true],
  ["/souq/payment/callback", "title.payment", true],
  ["/souq/listing/:listingId", "souq.title"],
  ["/regions", "region.title"],
  ["/regions/:slug", "region.title"],
];

export default function RouteMeta() {
  const { pathname } = useLocation();
  const { t, lang } = useApp();
  const hit = ROUTES.find(([p]) => matchPath({ path: p, end: true }, pathname));
  const label = (k) => (k.startsWith("kind:") ? KIND_LABEL[k.slice(5)][lang] : t(k));
  return (
    <Seo
      title={hit ? label(hit[1]) : t("title.notfound")}
      description={t("meta.desc")}
      noindex={!hit || Boolean(hit[2])}
    />
  );
}
